import React from "react";
import { Typography } from "../../design_system/StyledComponents/components/Typography.js";
import { Button } from "../../design_system/StyledComponents/components/Button";
import Undo from "../../assets/Undo.png";
import Redo from "../../assets/Redo.png";
import "./ButtonComponent.css";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useDispatch, useSelector } from "react-redux";
import {
  drawData,
  setDesignStep,
  showRoomNamePopup,
  showRoomSeperatorPopup,
  toggleTutorial,
  updateDrawData,
  restoreLinesAndPoints,
  setImageOpacity,
  setScaleSetState,
  setAutoDraw,
  setStoreLines,
} from "../../Actions/ApplicationStateAction.js";
import { ArrowBack, Check, WindowRounded } from "@mui/icons-material";
import { Switch } from "@mui/material";
import { setSeeDimensions, setTypeId } from "../../Actions/DrawingActions.js";
import {setSelectedButton} from "../../features/drawing/drwingSlice.js";
import { useActions } from "../../hooks/useActions.js";
import { resetShowFirstTimePopup, setShowFirstTimePopup } from "../../Actions/PopupAction.js";
import useModes from "../../hooks/useModes.js";
import book from "../../assets/book_3_outlined.svg"
import { Vector3 } from "three";

import DrawWithAIButton from "../../design_system/button/DrawWithAIButton.js";

const MySwal = withReactContent(Swal);

const DrawtoolHeader = ({ }) => {
  const dispatch = useDispatch();
  const { designStep, img, tutorialActive, backupLines, selectionMode, ScaleSetState, autoDraw } = useSelector((state) => state.ApplicationState);
  const { seeDimensions } = useSelector((state) => state.Drawing);
  const { perpendicularLine } = useSelector((state) => state.drawing);
  const { handleReset, handleResetRooms, handleSaveClick} = useActions();
  const { perpendicularHandler, toggleSelectionMode } = useModes();

  const handleBackToScale = () => {
    dispatch(resetShowFirstTimePopup());
    dispatch(setDesignStep(2));
    dispatch(setScaleSetState(false));
    handleReset();
    window.GAEvent("DrawTool", "ButtonClicked", "BacktoScale");
  };


  const handleBackToDrawing = () => {
    MySwal.fire({
      title: "Are you sure you want to go back?",
      html: `
          <p>You will lose the changes you have made here.</p>
        `,
      confirmButtonText: "Go back",
      showCancelButton: true,
      showCloseButton: true,
      customClass: {
        title: "swal2-title-custom",
        htmlContainer: "swal2-html-custom",
        actions: "swal2-actions-custom",
        confirmButton: "swal2-confirm-button-custom",
        cancelButton: "swal2-cancel-button-custom",
      },
      width: "350px",
      padding: "24px",
      borderRadius: "12px",
      backdrop: true,
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(setDesignStep(2));
        dispatch(showRoomNamePopup(false));
        handleResetRooms();
        dispatch(resetShowFirstTimePopup());
      }
    });
    window.GAEvent("DrawTool", "ButtonClicked", "BackToDrawing");
  };

  const handleSaveAndNext = () => {
    dispatch(showRoomSeperatorPopup(true));
    if (autoDraw) {
      dispatch(setAutoDraw(false))
    }


  window.GAEvent("DrawTool", "ButtonClicked", "SaveAndNext");
};

  const handleClick = () => {
    window.GAEvent("DrawTool", "ButtonClicked", "Save",designStep);
    if(tutorialActive){
      dispatch(toggleTutorial(false))
      dispatch(setTypeId(0))
      dispatch(setImageOpacity(0.4))
      dispatch(setSelectedButton(null))
      if(!selectionMode){
        toggleSelectionMode();
      }
      if(backupLines.length > 0){
        dispatch(restoreLinesAndPoints())
      }
      return
    }
    if(designStep === 2 && img){
      toggleSelectionMode();
      handleSaveAndNext(); // the new popup function here
      return
    }
    if (designStep===3){
      handleSaveClick()
      return
    }
    handleSaveAndNext();
    // handleSaveClick();
  }

  const handleSeeDimensions = () => {
    dispatch(setSeeDimensions(!seeDimensions));
    window.GAEvent("DrawTool", "ButtonClicked", "SeeDimensions", !seeDimensions );
  };

  const handleSlantedWallsTrigger = () => {
    perpendicularHandler();
    window.GAEvent("DrawTool", "ButtonClicked", "SlantedWalls", !perpendicularLine);
  };

  const BackToDrawing = () => {
    dispatch(setScaleSetState(false));
    setDesignStep(2);
  }

  const backToDashboard = () => {
    // window.location = process.env.REACT_APP_ROME_URL + ("/my-homes") 
    const timestamp = new Date().getTime();
    window.location = `${process.env.REACT_APP_ROME_URL}/my-homes?ts=${timestamp}`;
    dispatch(setScaleSetState(false));
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: "20px",
          left: "20px",
          backgroundColor: "white",
          borderRadius: "12px",
          width: "calc(100vw - 330px)",
          padding: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          boxShadow: "0px 4px 14px -3px #0C0C0D21",
          zIndex: "2",
          height: "30px",
        }}
      >
        <div className="header-step-indicator">
          {tutorialActive ? <img src={book} alt="tutorial" style={{height:"28px", width: "28px", marginRight:"8px"}}/>
          : designStep> 2?
            <div
                style={{
                  backgroundColor: "#F4F4F4",
                  padding: "4px 8px",
                  borderRadius: "8px",
                  marginRight:"8px",
                  cursor: "pointer",
                }}
                onClick={designStep === 2? handleBackToScale: handleBackToDrawing}
              >
                <ArrowBack
                  style={{
                    fontSize: "20px",
                    marginTop: "5px",
                  }}
                />
              </div>
            : 
            <div
                style={{
                  border: "1px solid #B6BABD",
                  padding: "4px 8px 6px 6px",
                  borderRadius: "8px",
                  marginRight:"8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "row",
                  gap: "4px",
                  cursor: "pointer",
                }}
                onClick={backToDashboard}
              >
                <ArrowBack
                  style={{
                    fontSize: "18px",
                    cursor: "pointer",
                  }}
                />
                <Typography>Exit</Typography>
              </div>
          }
          {tutorialActive ? <Typography modifiers={["medium", "header6", "black600"]}>Tutorial</Typography>: 
          <>
          {/* {!img? null: 
          <div className="header-step-indicator-step">
            <div className={`header-step-indicator-step-box ${designStep< 1? "grayBorder" : ""}`}>
              {
                designStep > 1 ?
                <Check style={{fontSize:"16px"}}/>
                :
                <Typography modifiers={["medium", "subtitle2", "black600"]}>1</Typography>
              }
            </div>
            <Typography modifiers={["medium", "subtitle", "black600"]}>Set scale</Typography>
          </div>}
          {!img ?null:
          <div className={`header-step-indicator-line ${designStep > 1 ? "blackLine" : "grayLine"}`}></div>} */}
          <div className="header-step-indicator-step">
            <div className={`header-step-indicator-step-box ${designStep< 2? "grayBorder" : ""}`}>
              {
                designStep > 2 ?
                <Check style={{fontSize:"16px"}}/>
                :
                <Typography modifiers={designStep > 1? ["medium", "subtitle2", "black600"]: ["grey","medium", "subtitle"]}>{1}</Typography>
              }
            </div>
            <Typography modifiers={designStep > 1? ["medium", "subtitle", "black600"]: ["grey","medium", "subtitle"]}>Draw plan</Typography>
          </div>
          <div className={`header-step-indicator-line ${designStep > 2 ? "blackLine" : "grayLine"}`}></div>
          <div className="header-step-indicator-step">
            <div className={`header-step-indicator-step-box ${designStep< 3? "grayBorder" : ""}`}>
              {
                designStep > 3 ?
                <Check style={{fontSize:"16px"}}/>
                :
                <Typography modifiers={designStep > 2? ["medium", "subtitle2", "black600"]: ["grey","medium", "subtitle"]}>{2}</Typography>
              }
            </div>
            <Typography modifiers={designStep > 2? ["medium", "subtitle", "black600"]: ["grey","medium", "subtitle"]}>Define Rooms</Typography>
          </div>
          {/* <div className={`header-step-indicator-line ${designStep > 3 ? "blackLine" : "grayLine"}`}></div>
          <div className="header-step-indicator-step">
            <div className={`header-step-indicator-step-box ${designStep< 4? "grayBorder" : ""}`}>
              {
                designStep > 3 ?
                <Check style={{fontSize:"16px"}}/>
                :
                <Typography modifiers={designStep > 3? ["medium", "subtitle2", "black600"]: ["grey","medium", "subtitle"]}>{!img? 3: 4}</Typography>
              }
            </div>
            <Typography modifiers={designStep > 3? ["medium", "subtitle", "black600"]: ["grey","medium", "subtitle"]}>Open 3D</Typography>
          </div> */}
        </>
        }
        </div>
        {tutorialActive? 
          <div style={{ display: "flex", gap: "8px" }}>
            <Button
              className="save-btn"
              modifiers={["blue"]}
              onClick={handleClick}
            >
              Draw my plan
            </Button>
          </div>
        :designStep === 1 ? null : (
          ScaleSetState? null :
          <div style={{ display: "flex", gap: "8px" }}>
            <Button
              className="save-btn"
              modifiers={["blue"]}
              onClick={handleClick}
            >
              {designStep < 3? "Save & next": "Finish & generate 3D" }
            </Button>
          </div>
        )
        }
      </div>
      {/* {designStep === 1 || tutorialActive ? null : (
        <div className="dimension-setter">
          <Typography modifiers={["subtitle2"]}>Dimensions</Typography>
          <label class="switch">
            <input
              className="dimension-switch"
              type="checkbox"
              checked={seeDimensions}
              onChange={handleSeeDimensions}
            />
            <span class="slider round"></span>
          </label>
        </div>
      )} */}
      {designStep === 2 && !ScaleSetState && !tutorialActive && img && (
        <DrawWithAIButton />
      )}

      {designStep === 1 || tutorialActive ? null : (
        <div className="dimension-setter slanted-walls-setter">
          <Typography modifiers={["subtitle2"]}>Slanted walls</Typography>
          <label class="switch">
            <input
              className="dimension-switch"
              type="checkbox"
              checked={!perpendicularLine}
              onChange={handleSlantedWallsTrigger}
            />
            <span class="slider round"></span>
          </label>
        </div>
      )}
    </>
  );
};

export default DrawtoolHeader;
